import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
  GetOfferDataRq,
  GetOfferDataRs,
  LoanCaseForOfferDTO,
} from "@smartx/mikro-vt-client-api"
import { offerDataApi } from "../../api/apiClient"
import type { RootState } from "../store"

interface IOfferDataState {
  error: boolean
  isLoading: boolean
  loanCaseForOffer: LoanCaseForOfferDTO
}

const initialState: IOfferDataState = {
  error: false,
  isLoading: false,
  loanCaseForOffer: null,
}

export const getOfferData = createAsyncThunk(
  "offerData/getOfferData",
  async (rq: GetOfferDataRq, thunkApi) => {
    const { rejectWithValue } = thunkApi
    try {
      const response = await offerDataApi.getOfferData(rq)

      if (!response?.data) {
        throw new Error("Missing data")
      }

      return response.data
    } catch (err: any) {
      return rejectWithValue(err?.message || "Error")
    }
  },
)

export const offerDataSlice = createSlice({
  name: "offerData",
  initialState,
  reducers: {
    setOfferData: (state, action: PayloadAction<GetOfferDataRs>) => {
      state.loanCaseForOffer = action.payload.loanCase
    },
    clearOfferData: (state) => {
      state.loanCaseForOffer = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOfferData.pending, (state) => {
        state.isLoading = true
        state.error = false
      })
      .addCase(getOfferData.fulfilled, (state, action) => {
        state.isLoading = false
        state.error = false
        state.loanCaseForOffer = action.payload.loanCase
      })
      .addCase(getOfferData.rejected, (state) => {
        state.isLoading = false
        state.error = true
      })
  },
})

export const { setOfferData, clearOfferData } = offerDataSlice.actions

export const selectOfferData = (state: RootState) =>
  state.offerData.loanCaseForOffer

export default offerDataSlice.reducer
